export default "__VITE_ASSET__58cc2a5c__"